import AuthButton from './AuthButton.mapper';

export default AuthButton;
